var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',_vm._b({attrs:{"bottom":"","close-delay":_vm.closeDelay || _vm.getConst('config').tooltip.timeout,"open-on-focus":false,"open-on-hover":false},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_vm._t("default",null,{"on":on})]}}],null,true)},'v-tooltip',_vm.$attrs,false),[_c('span',{staticClass:"text-caption"},[_vm._v(_vm._s(_vm.texto))])])}
var staticRenderFns = []

export { render, staticRenderFns }